import { render, staticRenderFns } from "./MainProjectOfferItem.vue?vue&type=template&id=4674babc&scoped=true&"
import script from "./MainProjectOfferItem.vue?vue&type=script&lang=js&"
export * from "./MainProjectOfferItem.vue?vue&type=script&lang=js&"
import style0 from "./MainProjectOfferItem.vue?vue&type=style&index=0&id=4674babc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4674babc",
  null
  
)

export default component.exports